import React from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { formatCount, formatPercent } from './format';

// "Fix before sharing externally": data gaps a partner would notice, worked
// out from the report itself. Renders nothing when there is nothing to fix.
export function dataQualityIssues(level, notes) {
  const issues = [];
  const projects = level?.projects;
  if ((projects?.cohorts_with_data ?? 0) > 0) {
    if ((projects.sdgs ?? []).length === 0) {
      issues.push('SDG mapping is empty for every goal.');
    }
    const unclassified = (projects.sectors ?? []).find(
      (sector) => sector.value === 'Unclassified'
    );
    if (unclassified?.learners) {
      issues.push(
        `${formatPercent(
          unclassified.percent
        )} of graduates' projects (${formatCount(
          unclassified.learners
        )} learners) have no industry.`
      );
    }
    if (projects.learners_without_partner > 0) {
      issues.push(
        `${formatCount(
          projects.learners_without_partner
        )} learners' projects name no partner.`
      );
    }
  }
  const withoutProgress = notes?.cohorts_without_progress_data ?? [];
  if (withoutProgress.length > 0) {
    issues.push(
      `${withoutProgress.length} cohort${
        withoutProgress.length === 1 ? ' has' : 's have'
      } no LMS progress data, so their learners can't be counted as active.`
    );
  }
  return issues;
}

function DataQualityPanel({ issues }) {
  if (!issues.length) return null;
  return (
    <section className="rounded-xl border border-amber-200 bg-amber-50 p-5">
      <h2 className="flex items-center gap-2 text-sm font-semibold text-amber-900">
        <WarningAmberIcon fontSize="small" />
        Fix before sharing externally
      </h2>
      <ul className="mt-3 grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2 list-disc pl-5 text-sm text-amber-900">
        {issues.map((issue) => (
          <li key={issue}>{issue}</li>
        ))}
      </ul>
    </section>
  );
}

export default DataQualityPanel;
